import { Link } from 'react-router-dom';
import { Modal, Stack, Text, Button, Group, ThemeIcon } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';

interface LoginPromptModalProps {
  opened: boolean;
  onClose: () => void;
  action?: string;
}

export function LoginPromptModal({ opened, onClose, action = 'do that' }: LoginPromptModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      radius="lg"
      withCloseButton={false}
      padding="xl"
    >
      <Stack align="center" gap="md">
        <ThemeIcon size={52} radius="xl" variant="light" color="brand">
          <IconLock size={26} />
        </ThemeIcon>
        <Stack align="center" gap={6}>
          <Text fw={700} size="lg" ta="center">Sign in to {action}</Text>
          <Text size="sm" c="dimmed" ta="center">
            Join CartCritic to interact with reviews, follow reviewers, and build your own profile.
          </Text>
        </Stack>
        <Group w="100%" grow>
          <Button component={Link} to="/register" radius="xl" onClick={onClose}>
            Sign up free
          </Button>
          <Button component={Link} to="/login" radius="xl" variant="subtle" onClick={onClose}>
            Log in
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
